/* stylelint-disable */
/*
 * Application global variables.
 */
/* stylelint-disable */
/* width */
.pes-partner-price-label {
  margin-top: 5px;
  margin-bottom: 0;
  color: #626469;
}

.product-card.list-view .pes-partner-price-label {
  margin-top: 0;
  margin-bottom: 10px;
  line-height: 17px;
}

@media screen and (min-width: 980px) {
  .pes-partner-price-label {
    font-size: 12px;
    line-height: 15px;
  }

  .product-card.list-view .pes-partner-price-label {
    line-height: 17px;
  }
}

.pes-partner-price-value {
  display: block;
  margin-top: 5px;
  font-size: 22px;
  line-height: 30px;
  color: #333333;
}

.pes-partner-price-value--mobile {
  font-size: 1.125rem;
  line-height: 32px;
}

.product-card.list-view .pes-partner-price-value {
  margin-top: 0;
  font-size: 20px;
  line-height: 1;
}

@media screen and (min-width: 980px) {
  .pes-partner-price-value {
    font-size: 18px;
  }

  .product-card.list-view .pes-partner-price-value {
    font-size: 20px;
  }
}